import { Model } from '@vuex-orm/core'

export default class User extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'user'

  static primaryKey = '_id'

  // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
  // The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      customer: this.attr(null),
      email: this.attr(''),
      firstName: this.attr(undefined),
      lastName: this.attr(undefined),
      username: this.attr(''),
      permissions: this.attr(undefined),
    }
  }

  static apiConfig = {}
}

export class UserRecord extends User {

  static entity = 'user_record'

  // Reference to base entity name.
  // static baseEntity = 'user'

  static fields () {
    return {
      ...super.fields(),
      active: this.attr(undefined),
      extern: this.attr(undefined),
      createdAt: this.attr(''),
      joinedAt: this.attr(''),
      lastActivity: this.attr(''),
      lastLogin: this.attr(''),
      password: this.attr(undefined),
      roles: this.attr([]),
      teams: this.attr([]),
      updatedAt: this.attr(''),
    }
  }
}